
import Vue from 'vue'
import router from './router'
import axios from 'axios'
const CancelToken = axios.CancelToken
import api from '@/api'
import utils from '@/assets/js/utils'
import common from '@/assets/js/common'
import store from '@/store'
import {
    HttpError
} from '@/config'

// 公用样式引入
import "@/assets/css/index.css"
import "@/assets/css/partel.css"
import "@/assets/css/addtab.css"
import "@/assets/css/varibles.styl"
import "@/assets/css/element-ui.styl"
import "@/assets/css/mint-ui.styl"
import passport from'@/assets/js/passport.js'
//按需加载css
function ifStyle(){
    //判断是pc或者移动
    if(navigator.userAgent.match(/(pad|ipad)/i)){
        if(navigator.userAgent.indexOf('com.longfor')>-1||navigator.userAgent.indexOf('kuaiyixing.CheYiXing')>-1){
            require('@/assets/css/mobile.css')
        }else{
            require('@/assets/css/pc.css')
        }
        return
    }

    if ((navigator.userAgent.match(/(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
        require('@/assets/css/mobile.css')
    }
    else {
        require('@/assets/css/pc.css')
    }
}
ifStyle()
Vue.prototype.api = api
Vue.prototype.$utils = utils
Vue.prototype.$common = common
Vue.config.productionTip = false // 关闭Vue默认格式化校验

/**
 * @func axios的二次封装
 * @param method-请求方法，uri-接口地址，data-请求参数, vm-Vue实例对象本身
 * @param 第四个参数固定为this，建议传来实现异常抛出操作，不传则需在页面自行处理catch异常
 */
Vue.prototype.$axios = function (method, uri, data, vm,style,ytem) {
    let params,paramData;
    if(method.toLocaleLowerCase() == 'get'){
        params = 'params'  // 判断请求方式
        paramData = Object.assign({},data,{
            "datetime2":new Date().getTime()
        })
    }else{
        params = 'data'
        paramData = data
    }

    return new Promise((resolve, reject) => {
        axios({
            method: method,
            url: uri,
            responseType:style,
            [params]: paramData
        }).then(r => {
            resolve(r)
        }).catch(e => {
            if (e.response.status ) {
                if(ytem){
                    ytem.bole = !ytem.bole
                    }
                let response = JSON.parse(JSON.stringify(e.response))
                let message = response.data && response.data.message;
                if(message.indexOf('不允许越权')>-1||message.indexOf('操作权限')>-1){
                    document.title = '流程平台'
                    this.$utils.message(vm, "error", message,2200)
                    this.$store.state.permission = false
                    this.$store.state.tabMessage = message
                    return false
                }
                else{ //message存在的情况下，弹框提示
                    if (response.data.code == "21045031") {
                        // 该环节不允许加签
                        this.$utils.message(vm, "error", message, 2000, parseInt((document.documentElement.clientHeight/10)/2));
                    } else if (response.data.code == "21045037" || response.data.code == "21045013") {
                        // 报21045037=工作项[xxx]不存在！21045013=流程不存在！
                        this.$utils.message(vm, "error", message, 2000, 15);
                    } else {
                        this.$utils.message(vm, "error", message)
                    }
                    return false
                }
            }
            arguments.length == 4 && vm && utils.throwError(vm, e)
            reject(e)
        })
    })
}
Vue.prototype.$requestAxios = function (method, uri, data, vm,style) {
    let params,paramData;
    if(method.toLocaleLowerCase() == 'get'){
        params = 'params'  // 判断请求方式
        paramData = Object.assign({},data,{
            "datetime2":new Date().getTime()
        })
    }else{
        params = 'data'
        paramData = data
    }

    return new Promise((resolve, reject) => {
        axios({
            method: method,
            url: uri,
            [params]: paramData,
            responseType: style ,
            cancelToken: new axios.CancelToken(function executor(c) { // 设置 cancel token
                vm.source = c;
              },

              )
        }).then(r => {
            resolve(r)
        }).catch(e => {
            console.log(e);

            if (e.response&&e.response.status) {
                let response = JSON.parse(JSON.stringify(e.response))
                let message = response.data && response.data.message;
                if(message.indexOf('不允许越权')>-1){
                    document.title = '流程平台'
                    this.$utils.message(vm, "error", message,2000)
                    return false
                }
                else{ //message存在的情况下，弹框提示
                    this.$utils.message(vm, "error", message)
                    return false
                }
            }
            // arguments.length == 4 && vm && utils.throwError(vm, e)
            // reject(e)
        })
    })
}

const API_DO_NOT_SHOW_LOADING_LIST = [
  "select",
  "form-url",
  "api/user",
  "through-train",
  "appoint-participants-config",
  "bpm-server/api/components/configurations",
  "process-views",
  "getUserAndTypeByUserName",
  "bpm-server/api/intersect/getGroupRecord" // 交圈记录分页接口
];
/**
 * @func 日期格式化
 * @param fmt:格式化规则字符串，如:'yyyy-MM-dd hh:mm:ss'
 */
Date.prototype.format = function (fmt) {
    let o = {
        'M+': this.getMonth() + 1, //月份
        'd+': this.getDate(), //日
        'h+': this.getHours(), //小时
        'm+': this.getMinutes(), //分
        's+': this.getSeconds(), //秒
        'q+': Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds() //毫秒
    }
    fmt = /(y+)/.test(fmt) ? fmt.replace(RegExp.$1,
        (this.getFullYear() + '').substr(4 - RegExp.$1.length)
    ) : fmt
    for (var k in o)
        fmt = new RegExp(`(${k})`).test(fmt) ? fmt.replace(RegExp.$1,
            RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
        ) : fmt
    return fmt
}

/**
 * 请求发起拦截器
 **/
let apikeyDev

if(window.location.host.indexOf('bpm3-sit-usa')>-1||window.location.host.indexOf('longfor.sit')>-1||window.location.host.indexOf('bpm3sit')>-1){
    apikeyDev = '46d096f0-2912-48c3-9733-7246f2690166'
}

if(window.location.host.indexOf('bpm3suat')>-1||window.location.host.indexOf('longfor.uat')>-1||window.location.host.indexOf('bpm3uat')>-1){
    apikeyDev = 'a8156bed-5cba-4034-b8f7-ff3864b10735'
}

if(window.location.host.indexOf('bpm3-dev')>-1){
    apikeyDev = 'fde25df7-2e11-4929-a8c8-e77a4eb187f1'
}

if(window.location.host.indexOf('bpm3.longhu.net')>-1||window.location.host.indexOf('bpm3.longfor.com')>-1||window.location.host.indexOf('bpm3.platanus.com')>-1){
    apikeyDev = '8654386b-65ce-482f-883c-d039724ee976'
}

axios.interceptors.request.use(
    config => {
        if (config.url.indexOf('bpm3-carbon') > -1) {
            config.headers.common = Object.assign({}, config.headers.common, {
                // 'X-Gaia-Api-Key': process.env.API,
                // 'X-Gaia-Api-Key': APIKEY.key,
                'X-Gaia-Api-Key':apikeyDev
            })
        }

        if(config.url.indexOf('https://intranetcheck.longfor.com/network') === -1){
          // 请求头信息
          config.headers.common = Object.assign({}, config.headers.common, {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-ER-Tenant-Info': utils.getUrlParam().sysId,
            'crossDomain': true,
            'X-ER-System-Info': 'default',
            // 'X-Gaia-Api-Key':'a8156bed-5cba-4034-b8f7-ff3864b10735',
            // 'X-Gaia-Api-Key':'46d096f0-2912-48c3zhuanfa-9733-7246f2690166',
            'Accept-Language': 'zh-CN',
          })
        }

        //根据域名动态添加请求头信息
        if(window.location.host.indexOf('localhost:808')>-1){
            // config.headers.common[ 'X-Gaia-Api-Key'] =  'a8156bed-5cba-4034-b8f7-ff3864b10735',
            config.headers.common[ 'X-Gaia-Api-Key'] =  '46d096f0-2912-48c3-9733-7246f2690166',
            //aGVpcGVuZw==  heipeng   bGl1eWFua2Fp 刘衍凯  emhlbmdzaHVhbmdsb25n 郑双龙 bGl1bGlmYW5n 刘丽芳  c3Vud2VpNg==  Y2hlbmRh  eWFuZ3FpZmFu emhhb3ppcWlhbg==赵梓茜  eWluaGFvMw== yinhao3 杨玉斌eWFuZ3l1Ymlu 白彩玲 YmFpY2FpbA== 陈雯雯 Y2hlbndlbndlbjE= 牛蕊刚 bml1cnVpZ2FuZw== 王娜王娜 d2FuZ25hMw==   wuliang d3VsaWFuZw==  郭强 Z3VvcWlhbmcx baibing1 YmFpYmluZzE=   xuhong6 eHVob25nNg== linzq bGluenE=  aibin YWliaW4= 范例 ZmFubGk= 朱丹 emh1ZGFu  杨峰9  eWFuZ2Zlbmc5 康建东 a2FuZ2ppYW5kb25n  龚焕新 Z29uZ2h1YW54aW4= 无锡 d3V4aQ==      白亮 YmFpbGlhbmc=  李明明   bGltaW5nbWluZw==   任毅  cmVueWk= cmVuc2hq zhaoqian emhvdXFpYW8=  YS1saWp1bmxlaQ==   shenying1 c2hlbnlpbmcx yanying3 yanyi3 eWFueWkz  chenting luoqing  Y2hlbnRpbmc=  Y2FvZGFucWluZw==  yangbaogang eWFuZ2Jhb2dhbmc= eWFuZ3hpYW9saXU= bGl1eWluZzIz
            config.headers.common[ 'X-ER-User-Info'] =  'aGVpcGVuZw=='
            config.headers.common['X-ER-Gateway-Token'] = 'YnBtIGdhdGV3YXk='
        }
        //重新从url里获取参数  不用传的参数
        let uri = config.url;
        (function () {
            let urlParam = utils.getUrlParam();
            let apiParam = utils.getUrlParam(uri)
            let reg = /\{[\S]{1,100}\}/
            if (reg.test(uri)) { //如果是斜杠传参
                let param = String(uri.match(reg)).split('.')[1].split('}')[0]
                uri = uri.replace(reg, urlParam[param])
            }

            if(!uri.includes('api/iam/user/getUserListBySearchText?instanceId') ){
                for (let key in apiParam) { //如果是问号传参
                    if (urlParam[key]) {
                        apiParam[key] = urlParam[key]
                    }
                }
            }

            delete apiParam.route
            let urlP = utils.objSerialize(apiParam);
            uri = uri.split('?')[0] + urlP
        })();

        config.url=uri
        try{

        }catch(e){

        }

        if (config.url.indexOf('https://intranetcheck.longfor.com/network') === -1) {
            let bpmssoToken = "";
            let xErTgcToken = "";

            if(store.state.ssoToken && store.state.ssoToken!=="undefined" && store.state.ssoToken!=="null"){
                bpmssoToken = store.state.ssoToken;
            }

            if(utils.getUrlParam().token && utils.getUrlParam().token!=="undefined" && utils.getUrlParam().token!=="null"){
                xErTgcToken = utils.getUrlParam().token;
            }

            config.headers.common = Object.assign({}, config.headers.common, {
                'bpmsso-token':bpmssoToken,
                'x-er-tgc-token': xErTgcToken,
            })
        }
        if(API_DO_NOT_SHOW_LOADING_LIST.every(item => config.url.indexOf(item) === -1)){
            common.showFullScreenLoading(); // 加载loading
        }
        config.timeout = 8000000 // 设置超时时间
        return config
    },
    err => null
)

/**
 * 请求响应拦截器
 **/
axios.interceptors.response.use(
    res => {
        if(API_DO_NOT_SHOW_LOADING_LIST.every(item => res.config.url.indexOf(item) === -1)){
            common.tryHideFullScreenLoading(); // 关闭loading
        }
        try {
            // TODO: set response pre-judge-handler
        } catch (e) {
            utils.throwError(e)
        }
        return res
    },
    err => {
        console.log(err);
        if(err.message==='终止请求'){
            common.tryHideFullScreenLoading(); // 关闭loading
            return Promise.reject(err)
        }
        common.tryHideFullScreenLoading(); // 关闭loading
        common.tryHideFullScreenLoading(); // 关闭loading
        if (err.response.status == '401') { //未授权时跳转至登录页面
            // let url = err.response.data.loginUrl
            // setTimeout(() => {
            //     window.location.href =  passport.login() + encodeURIComponent(location.href)
            //     }, 200);
            let url = err.response.data.loginUrl
            if(!store.state.isPc){
                router.replace('/error401')
            }else{
                setTimeout(() => {
                    window.location.href =  passport.login() + encodeURIComponent(location.href)
                }, 200);
            }
            try {
                let cookieVal = ''
                var strCookie = document.cookie;
                var arrCookie = strCookie.split("; ");
                for(var i = 0; i < arrCookie.length; i++){
                    var arr = arrCookie[i].split("=");
                    if('CASTGC' == arr[0]){
                        cookieVal =  cookieVal+'; ' + arr[1];
                    }
                }
                if(!store.state.isPc){
                }

            } catch (e) {
            }
        }
        let msg = err.toString().indexOf('timeout') != -1 ? '请求超时，请稍后再试' : '请求错误'
        err && err.response && (msg = HttpError[err.response.status])
        // 判断服务器错误提示：21045开头显示message，否则提示  状态码不是21050002"
        if(err.response.data.code.indexOf('21045')=='-1' && err.response.data.code.indexOf('2105')=='-1'){  // 不是21045开头
            err.response.data.message = '服务器内部错误，请稍后再试!'
        }
        return Promise.reject(err)
    }
)
Vue.prototype.axios = axios

export {
    Vue
}



// WEBPACK FOOTER //
// ./src/hook.js